
import Products from '~/components/Products/index.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: { Products },
  middleware: ['returnUrl', 'onlyRedirectProject'],
  watch: {
    $route: {
      deep: true,
      handler() {
        this.keyComp = this.keyComp + 1
      },
    },
  },
  async asyncData({ store, route, redirect }) {
    const [id, domain] = route.params.categoryId.split('-')
    const filter = {
      page: 1,
      search: '',
      limit: 12,
      lang: '',
      categoryId: Number(id),
      currency: store.getters['user/getUserIP'].currency,
    }
    const categories = store.getters['categories/getCategories']
    const category = categories.find((c) => c.id === filter.categoryId)
    if (category === undefined) redirect('/error')
    const query = route.query
    if (!isNaN(Number(query.page))) filter.page = query.page
    if (query.q) filter.search = encodeURI(query.q)
    if (query.lang) filter.lang = query.lang
    await store.dispatch('products/GET_PRODUCTS', filter)
    return {
      filter,
      category,
      keyComp: 0,
      products: store.getters['products/getProducts'],
      count: store.getters['products/getProductsCount'],
      page: filter.page,
      pages: Math.ceil(store.getters['products/getProductsCount'] / 12),
      startCount: (filter.page - 1) * 12,
      endCount:
        filter.page * 12 > store.getters['products/getProductsCount']
          ? store.getters['products/getProductsCount']
          : filter.page * 12,
    }
  },
  head() {
    const pageTitle = `${this.category.name} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('seo.pages.categoryListing.description', {
        name: this.category.name,
      }),
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  methods: {
    async SET_PAGINATION(page) {
      this.page = page
      this.startCount = (page - 1) * 12
      this.endCount =
        page * 12 > this.$store.getters['products/getProductsCount']
          ? this.$store.getters['products/getProductsCount']
          : page * 12
      await this.$store.dispatch('products/GET_PRODUCTS', {
        page,
        search: this.filter.search,
        limit: 12,
        categoryId: this.filter.categoryId,
        currency: this.$store.getters['user/getUserIP'].currency,
      })
      document.getElementById('list').scrollIntoView({ behavior: 'smooth' })
    },
  },
}
